import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { AppSettings } from '../app.settings';
import { ToastrService } from 'ngx-toastr';
import { Response } from '../models/response.model';
import { SustainabilityItem } from '../interfaces/sustainability-item';
import { isEmptyArray } from '../shared/utils';

@Injectable()
export class ContentService extends BaseService {
  public clearanceUrl = '';
  public truckGraphicsUrl = '';
  public repackUrl = '';

  public sustainabilityItems: SustainabilityItem[] = [];

  constructor(
    protected http: HttpClient,
    protected appSettings: AppSettings,
    protected toastr: ToastrService
  ) {
    super('/content', http, appSettings, toastr);
  }

  get(key: string, force = false): Observable<any> {
    if (this.cache.has(key) && !force) {
      return of(this.cache.get(key));
    }

    let url = `${this.apiURL}?uri=${key}`;
    if (key === 'latest-news') {
      url = `${this.baseUrl}/latest-news`;
    }

    return this.http.get<Response>(url).pipe(
      map((response) => {
        const data = response.data;
        this.cache.set(key, data);
        return data;
      }),
      catchError(this.handleError('ContentService::get', null))
    );
  }

  public getTerms(): Observable<string> {
    return this.get('terms').pipe(
      map((result) => {
        if (!result) {
          return '';
        }
        return result.data || '';
      })
    );
  }

  public getLatestNews(): Observable<string> {
    return this.get('latest-news', true).pipe(
      map((result) => {
        if (!result) {
          return '';
        }
        return result || '';
      })
    );
  }

  public getFAQ(): Observable<any> {
    return this.get('faq').pipe(
      map((response) => {
        if (response?.data) {
          return JSON.parse(response.data);
        }
        return '';
      })
    );
  }

  public getClearanceUrl() {
    this.get('navlink-clearance').subscribe((response) => {
      this.clearanceUrl = response.data || '';
    });
  }

  public getTruckGraphicsUrl() {
    this.get('navlink-truck-graphics').subscribe((response) => {
      this.truckGraphicsUrl = response.data || '';
    });
  }

  public getRepackUrl() {
    this.get('navlink-repack').subscribe((response) => {
      this.repackUrl = response.data || '';
    });
  }

  public getSustainabilityItems() {
    if (isEmptyArray(this.sustainabilityItems)) {
      this.fetchSustainabilityItems().subscribe((result) => {
        if (!isEmptyArray(result)) {
          this.sustainabilityItems = result;
        }
      });
    }
  }

  private fetchSustainabilityItems(): Observable<SustainabilityItem[]> {
    const url = `${this.appSettings.settings.apiBaseURL}/sustainability`;
    return this.http.get<Response>(url).pipe(
      map((response) => {
        if (!isEmptyArray(response?.data)) {
          return response.data;
        }
        return [];
      }),
      catchError(
        this.handleError('ContentService::fetchSustainabilityItems', [])
      )
    );

    // const mockedItems: SustainabilityItem[] = [
    //     {
    //         type: 'recyclable',
    //         label: 'Recyclable',
    //         icon: '/assets/img/icons/recycle-sign.svg',
    //         description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam gravida metus eget ultrices vulputate. Quisque neque lacus, commodo ut dignissim quis, volutpat quis leo. Curabitur semper odio eu fermentum rhoncus. Proin dignissim ligula odio, sed rhoncus magna tristique nec. Sed sed pretium ex. Aenean id mi vitae nunc facilisis molestie. Aenean et lobortis ex, ut euismod diam. Interdum et malesuada fames ac ante ipsum primis in faucibus. Quisque vitae vestibulum tortor. Proin vel ante at nisl luctus feugiat. Duis ornare lobortis augue et pulvinar. Nulla auctor sagittis est vel maximus. Aenean venenatis pretium cursus'
    //     },
    //     {
    //         type: 'recycled-materials',
    //         label: 'Recycled Materials',
    //         icon: '/assets/img/icons/rabbit-inside.svg',
    //         description: 'Sed bibendum non odio nec accumsan. In pharetra dolor at lacus vestibulum, vel consectetur nunc lobortis. Nulla bibendum sem sit amet metus pulvinar sodales. Duis dictum ligula quis lectus sagittis, non ornare eros finibus. Maecenas facilisis convallis nisi ut venenatis. Etiam aliquam orci at nulla tristique, eu blandit magna euismod. Proin tincidunt ex et nisl congue feugiat. Praesent porttitor at purus ut sodales. Aenean at congue felis, et facilisis lorem. Sed scelerisque scelerisque nulla, at aliquet massa tincidunt sit amet. Phasellus quis tellus et ex accumsan rutrum. Mauris porta metus ac semper posuere.'
    //     }
    //
    // ];

    // return of(mockedItems);
  }
}
